/* eslint-disable no-shadow */ // Copied from original events, TODO: Remove any kind of excepction
import { useMemo, useCallback, useEffect, useState, useRef } from 'react'
import styled from 'styled-components'
import {
  formatEventDate,
  getDateRangeDisplayInputValue,
  formatDateDayPicker,
  parseDateDayPicker
} from '@utils/events'
import { DateUtils } from 'react-day-picker'
import { Icon } from '@mch-group/uikit-components'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import { useModuleContext } from '../../contexts/EventsContext'
import usePush from '../../hooks/usePush'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'

// Access Filter usually titled in screen as "Type"
const DayFilterWrapper = () => {
  const { pushChange, pushFullChange } = usePush()
  //@ts-ignore
  const [{ labels, filters, router }] = useModuleContext()

  const routerQuery = router.query

  const [datePickerRange, setDatePickerRange] = useState({ from: undefined, to: undefined })

  const eventDay = useMemo(() => filters.find((filter) => filter.entityType === 'AVAILABLE_DAYS').options
    ? filters.find((filter) => filter.entityType === 'AVAILABLE_DAYS').options.map(item => new Date(item.code))
    : [], [filters])

  const isDayDisabled = useCallback(day => !eventDay.some(
    eventDay =>
      (DateUtils.isSameDay(day, new Date()) && DateUtils.isSameDay(new Date(), eventDay)) ||
      DateUtils.isSameDay(day, eventDay)
  ), [eventDay])

  const calendarDateFormat = 'ddd DD MMM YYYY'
  const modifiersStyles = {
    eventDay: {
      color: tokens.color.base.primary.black.value
    }
  }

  const toDateRef = useRef()

  // The author of the refactor of Events Browse page, couldn't find when this function is used (this code was moved
  // from the initial Events page).
  // Even when selecting a single day, this is not triggered. Clarify if anyone finds.
  const setSingleDate = useCallback(() => {
    if (datePickerRange.from && !datePickerRange.to) {
      pushChange(formatEventDate(datePickerRange.from), 'date')
    }
  }, [datePickerRange.from, datePickerRange.to, pushChange])

  const setDateRange = useCallback((day) => {
    const { from } = datePickerRange
    let params = { ...routerQuery }
    if (from && day) {
      // Cleaning any previous date filters
      delete params.to
      delete params.from
      delete params.date

      setDatePickerRange(prev => ({ ...prev, to: day }))

      if (new Date(from).getTime() === new Date(day).getTime()) {
        params.date = formatEventDate(from)
      } else {
        params.startDate = `${formatEventDate(from)}T00:00:00`
        params.endDate = `${formatEventDate(day)}T23:59:00`
      }
    // On press the X button
    } else {
      delete params.date
      delete params.startDate
      delete params.endDate
    }
    pushFullChange(params)
  }, [datePickerRange, routerQuery, pushFullChange])



  useEffect(() => {
    setDatePickerRange({
      from:
        (routerQuery.date && new Date(routerQuery.date)) ||
        (routerQuery.startDate && new Date(routerQuery.startDate)) ||
        undefined,
      to:
        (routerQuery.date && new Date(routerQuery.date)) ||
        (routerQuery.endDate && new Date(routerQuery.endDate)) ||
        undefined
    })
  }, [routerQuery.date, routerQuery.startDate, routerQuery.endDate])

  return (
    <DayPicker>
      <label htmlFor='day'>{labels.Events.browseFilterDay}</label>
      <div className='DayPickerInput'>
        <input
          type='text'
          value={getDateRangeDisplayInputValue(datePickerRange.from, datePickerRange.to, labels.Events.browseFilterAll)}
          readOnly
          aria-label={labels.Events.browseFilterDay}
        />
      </div>
      {/** @ts-ignore */}
      <DayPickerInput
        placeholder={labels.Events.browseFilterAll}
        value={datePickerRange.from}
        //@ts-ignore
        onDayChange={day => setDatePickerRange({ from: day, to: undefined })}
        dayPickerProps={{
          selectedDays: [datePickerRange.from, { from: datePickerRange.from, to: datePickerRange.to }],
          modifiers: {
            eventDay,
            start: datePickerRange.from,
            end: datePickerRange.to
          },
          modifiersStyles,
          disabledDays: isDayDisabled,
          //@ts-ignore
          onDayClick: (_, modifier) => !modifier.disabled && toDateRef.current.getInput().focus()
        }}
        inputProps={{
          readOnly: true,
          name: 'from'
        }}
        format={calendarDateFormat}
        formatDate={formatDateDayPicker}
        parseDate={parseDateDayPicker}
        aria-label='from'
      />
      {/** @ts-ignore */}
      <DayPickerInput
        ref={toDateRef}
        placeholder={labels.Events.browseFilterAll}
        value={datePickerRange.to}
        onDayChange={setDateRange}
        dayPickerProps={{
          selectedDays: [datePickerRange.from, { from: datePickerRange.from, to: datePickerRange.to }],
          modifiers: {
            eventDay,
            start: datePickerRange.from,
            end: datePickerRange.to
          },
          modifiersStyles,
          disabledDays: [isDayDisabled, { before: datePickerRange.from }],
          month: datePickerRange.from
        }}
        inputProps={{
          readOnly: true,
          name: 'to'
        }}
        format={calendarDateFormat}
        formatDate={formatDateDayPicker}
        parseDate={parseDateDayPicker}
        onDayPickerHide={setSingleDate}
        aria-label='to'
      />
      {datePickerRange.from && datePickerRange.to && (
        <ClearIcon
          type='button'
          onClick={() => setDateRange(undefined)}
        >
          <Icon name='close' />
        </ClearIcon>
      )}
      <Icon name='chevron-down' size={26} className='align-chevron-down-icon' />
    </DayPicker>
  )
}

const DayPicker = styled.div`
  position: relative;
  z-index: 999;

  @media (min-width: ${global.uikitVars.breakpointMdMax}) {
    height: 100%;
  }

  label {
    font-weight: 700;
  }

  .DayPickerInput {
    position: absolute;
    left: 0;
    bottom: 0;
    top: 32px;
    width: 100%;
    border-bottom: none;

    @media (max-width: ${global.uikitVars.breakpointMdMax}) {
      top: 20px;
    }

    &:first-of-type {
      pointer-events: none;
      z-index: 2;

      @media (max-width: ${global.uikitVars.breakpointMdMax}) {
        position: static;
      }
    }

    &:nth-of-type(2) {
      z-index: 1000;

      @media (max-width: ${global.uikitVars.breakpointMdMax}) {
        height: 100%;
      }

      border-bottom: 1px solid #bdbdbd !important;
    }

    input {
      border: none;
      width: 100%;
    }

    &:not(:first-of-type) {
      input {
        opacity: 0;
      }
    }

    &-Overlay {
      z-index: 2;
    }

    .DayPicker-Day--selected:not(.DayPicker-Day--outside) {
      &,
      &.DayPicker-Day--disabled {
        background: ${tokens.color.light.base.neutrals['500'].value};
      }

      &:not(.DayPicker-Day--disabled) {
        color: var(--bs-mch-black) !important;
      }

      &.DayPicker-Day--disabled {
        color: ${tokens.color.light.base.neutrals['300'].value} !important;
      }

      &.DayPicker-Day--start,
      &.DayPicker-Day--end {
        color: var(--bs-mch-white) !important;
        background: var(--bs-mch-gray-500);
      }
    }
  }

  .align-chevron-down-icon {
    right: -2px;
    z-index: 2;
    position: absolute;
    top: 34px;
  }
`

const ClearIcon = styled.button<any>`
  position: absolute;
  right: 24px;
  bottom: 9px;
  z-index: 1000;
  display: block;
  padding: 8px;
  line-height: 1;
  background: transparent;
  border: none;
  cursor: pointer;

  svg {
    width: 15px;
    height: 15px;
  }
`


export default DayFilterWrapper
